<div class="building-blocks-menu-item" (click)="onClick()">
  <div [ngClass]="getDataStyle('building-blocks-menu-item-child')">
  </div>
  <div class="frame-parent">
    <button type="button" class="menu-item-button" [class.is-active]="isActive()" >

      <div [ngClass]="navItem.parentMenuId ? 'iconshome-parent-sub' : 'iconshome-parent'">
        @if (navItem.icon) {
          <span class="item-icon" [style.--icon-url]="getIcon()" aria-hidden="true"></span>
        } @else {
          <span class="iconshome"></span>
        }
        <div class="menu-item-wrapper">
          <div class="menu-item">
            {{ 'navigation.menuOptions.' + navItem.label | translate }}
          </div>
        </div>
        @if (navItem.subItem) {
          <img class="frame-child" [src]="getSubItemImage()">
        }
      </div>
    </button>
  </div>
</div>

